import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './LandingPage.css';
import './i18n/config';
import LandingPage from './components/LandingPage';
import CodeBrowser from './components/CodeBrowser';

// 静态文件列表
const STATIC_FILES = ['/sitemap.xml', '/robots.txt', '/favicon.ico', '/manifest.json'];

function App() {
  // 如果是静态文件路径，不渲染React应用
  if (STATIC_FILES.includes(window.location.pathname)) {
    return null;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/browser" element={<CodeBrowser />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;